import { Dispatch } from "react";
import { SxProps, TextField, Theme } from "@mui/material";
import StyledAutocomplete from "./StyledAutocomplete";
import { CancerStage, CancerStageCount, displayCancerStage } from "Backend";

export interface CancerStageSelectProps {
  options?: CancerStageCount[];
  value: CancerStage[];
  setValue: Dispatch<CancerStage[]>;
  sx?: SxProps<Theme>;
}

const CancerStageSelect = (props: CancerStageSelectProps) => {
  const { value, setValue } = props;

  const options: CancerStageCount[] =
    props.options ||
    ["0", "I", "II", "III", "IV", "unstaged"].map((cs) => ({ cancerStage: cs as CancerStage, count: 0 }));

  return (
    <StyledAutocomplete
      sx={props.sx}
      multiple
      size="small"
      freeSolo={false}
      onChange={(_evt: any, values: any) => {
        setValue(values.map((c: any) => c.cancerStage));
      }}
      value={value.map((cs) => ({ cancerStage: cs, count: 0 }))}
      renderOption={(p, opt: any) => (
        <li {...p}>
          {displayCancerStage(opt.cancerStage)} ({opt.count})
        </li>
      )}
      getOptionLabel={(opt: any) => displayCancerStage(opt.cancerStage)}
      renderInput={(params: any) => {
        return <TextField {...params} label="Stage" fullWidth />;
      }}
      options={options}
    />
  );
};

export default CancerStageSelect;
